<form>
   <input
      type="checkbox"
      id="showDialpad"
      [checked]="showDialpadSetting$ | async"
      (click)="changeShowDialpad($event.currentTarget.checked)"
      class="k-checkbox"
   />
   <label class="k-checkbox-label" for="showDialpad">{{
      'brick.brick_definitions.call_control.settings.show_dialpad_title' | translate
   }}</label>
</form>
